type FormatValueOptions = {
  decimalPlaces?: number;
  allowZero?: boolean;
  allowRounding?: boolean;
  nullValue?: string;
  multiplier?: number;
  trailingZeroes?: boolean;
};

export const abbreviateNumericValue = (value: number | null | undefined, options: FormatValueOptions = {}) => {
  const {
    decimalPlaces = 2,
    allowZero = false,
    allowRounding = false,
    nullValue = '-',
    multiplier = 1,
    trailingZeroes,
  } = options;

  if (value === null || value === undefined) return nullValue;
  if (value === 0) return allowZero ? '0' : nullValue;

  const threshold = 1 / 10 ** decimalPlaces;
  if (value * multiplier > 0 && value * multiplier < threshold) {
    return `<${threshold.toFixed(decimalPlaces)}`;
  }

  if (allowRounding && value > 0) {
    const localMultiplier = 10 ** decimalPlaces;
    const roundedValue = Math.round(value * localMultiplier) / localMultiplier;
    return (roundedValue * multiplier).toFixed(decimalPlaces);
  }

  const formatter = new Intl.NumberFormat('en-US', {
    compactDisplay: 'short',
    maximumFractionDigits: decimalPlaces,
    minimumFractionDigits: trailingZeroes ? decimalPlaces : 0,
    notation: 'compact',
  });

  return formatter.format(value * multiplier);
};
